import { userAxios } from '../index'
import { runStaggered } from '@/core/utils/requestPacing'
import { withAllDataDates, withBackendDates } from '@/core/utils/dashboardDates'
import { abortableRequest } from '@/core/utils/abortableRequest'

/** Lanza el error (422 incluido) para que el dashboard muestre el mensaje del backend. */
const getData = async (data, { signal } = {}) => {
  return abortableRequest(signal, config =>
    userAxios
      .post(`dashboard/get-data`, withBackendDates(data), config)
      .then(res => res.data)
  )
}

const getDataAll = async data => {
  try {
    return await userAxios
      .post(`dashboard/all-data`, withAllDataDates(data))
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

/**
 * Totales del Dashboard total (carril regular). Fechas `Y-m-d`.
 * `average.summary.total` para ponderar entre bloques.
 */
const getAllValuesTotals = async data => {
  try {
    return await userAxios
      .post(`dashboard/all-values-totals`, withAllDataDates(data))
      .then(res => res.data)
  } catch (error) {
    console.error('Error fetching all-values-totals:', error)
    throw error
  }
}

const getAllDashboardData = async (data, { signal } = {}) => {
  try {
    const payload = withAllDataDates(data)
    const post = url =>
      abortableRequest(signal, config =>
        userAxios.post(url, payload, config).then(res => res.data)
      )
    const [allDataCount, allPatients, totalRefunds, yearData, bonus, valuesTotals] =
      await runStaggered([
        () => post(`dashboard/all-data-patients-count`),
        () => post(`dashboard/all-data-patients`),
        () => post(`dashboard/all-data-total-refounds`),
        () => post(`dashboard/all-data-year-data`),
        () => post(`dashboard/all-data-bonus`),
        () => post(`dashboard/all-values-totals`),
      ])

    return {
      allDataCount: allDataCount,
      all_patients: allPatients,
      total_refunds: totalRefunds,
      year_data: yearData,
      bonus: bonus,
      values_totals: valuesTotals,
    }
  } catch (error) {
    if (error?.name !== 'AbortError') {
      console.error('Error fetching dashboard data:', error)
    }
    throw error
  }
}

const cashView = async id => {
  try {
    return await userAxios.get(`cashControl/${id}`).then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const cashGlobalClose = async data => {
  try {
    return await userAxios
      .post(`cashControl/clinicCash/closing`, data)
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const cashGlobalDaily = async () => {
  try {
    return await userAxios.get(`cashControl/admin`).then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const cashGlobalHistory = async (id, perPage) => {
  try {
    return await userAxios
      .get(`cashControl/admin/clinic/${id}/${perPage}`)
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

const getDoctorsChart = async data => {
  return userAxios
    .post('dashboard/doctors-chart', withBackendDates(data))
    .then(res => res.data)
}

const getDoctorsRanking = async data => {
  return userAxios
    .post('dashboard/doctors-ranking', withBackendDates(data))
    .then(res => res.data)
}

const attachFile = async data => {
  try {
    return await userAxios
      .post(`cashControl/clinicCash/attach`, data)
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

import progressiveLoader from './progressiveLoader'

export default {
  getData,
  getDataAll,
  getAllValuesTotals,
  getAllDashboardData,
  getDoctorsChart,
  getDoctorsRanking,
  progressiveLoader,
}
